export interface GuessDisplayTitleParams {
    groupTitle?: string | null;
    guessTitle?: string | null;
    title?: string | null;
}

export function getGuessDisplayTitle( params: GuessDisplayTitleParams ): string {
    const groupTitle = String( params.groupTitle ?? "" ).trim();
    const guessTitle = String( params.guessTitle ?? "" ).trim();
    const title = guessTitle || String( params.title ?? "" ).trim();

    if ( groupTitle && title ) return `${groupTitle} - ${title}`;
    return title || groupTitle;
}

export function moveDrawGuessToCenter<T>( guessList: T[], getGuessTitle: ( guess: T ) => unknown ): T[] {
    const drawIndex = guessList.findIndex( ( guess ) => String( getGuessTitle( guess ) ?? "" ).trim() === "Draw" );
    if ( drawIndex < 0 ) return guessList;

    const centerIndex = Math.floor( guessList.length / 2 );
    if ( drawIndex === centerIndex ) return guessList;

    const sortedGuessList = [ ...guessList ];
    const [ drawGuess ] = sortedGuessList.splice( drawIndex, 1 );
    sortedGuessList.splice( centerIndex, 0, drawGuess );

    return sortedGuessList;
}
